module.exports = __webpack_public_path__ + "static/media/6.8884b703.svg";